import { useEffect, useState } from 'react'

/* login social */
import { Auth, Hub } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { useTranslation } from 'react-i18next';
import { PWelcomeNew, UserLogin } from 'libs/raas-ui-react-components/src/components';

export const TestLoginSocial = (props: any) => {

    const [user, setUser] = useState(null as any);
    const [customState, setCustomState] = useState(null as any);


    useEffect(() => {
        const unsubscribe = Hub.listen("auth", ({ payload: { event, data } }) => {
            console.log('useEffect: ', data);
            /* setStorage (usersession) */
            switch (event) {
                case "signIn":
                    setUser(data);
                    break;
                case "signOut":
                    setUser(null);
                    break;
                case "customOAuthState":
                    setCustomState(data);
            }
        });

        Auth.currentAuthenticatedUser()
            .then(currentUser => setUser(currentUser))
            .catch(() => console.log("Not signed in"));

        return unsubscribe;
    }, []);


    const handleLoginSocial = ({ detail }: CustomEvent) => {
        console.log({ detail });
        Auth.signOut()
            .then((value: any) => {
                console.log('¡deslogueado!', value);

                const promiseAuth = getPromiseByProvider(detail);
                if (promiseAuth) {
                    promiseAuth
                        .then((response: any) => {
                            console.log('promiseAuth done', response);
                            sessionStorage.setItem('auth-login-social', JSON.stringify(response));
                            // if let cognitoTokens = try?tokenProvider.getCognitoTokens().get() {
                            //     self.handleSuccess(modelBusiness: SessionTokenModelBusiness(cognitoTokens: cognitoTokens))
                            // }
                        })
                        .catch((error: any) => {
                            sessionStorage.setItem('auth-login-social-error', JSON.stringify(error));
                            console.log('promiseAuth error', error);
                        })
                        .finally(() => {
                            console.log('getPromiseByProvider finished');
                        })
                }
            })
            .catch((error) => console.log('No se ha podido desloguear: ', error));

    }

    const getPromiseByProvider = (provider: string) => {
        switch (provider) {
            case 'google': return Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });
            case 'facebook': return Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Facebook });
            case 'apple': return Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Apple });
        }
    }

    // translations

    function getLiteralsHome(t: any) {
        return {
            header: {
                buttonLeft: t('header.buttonLeft'),
                buttonRight: t('header.buttonRight'),
                maintext: t('header.maintext'),
            },
            content: {
                welcome: t('content.welcome'),
                title: t('content.title'),
                main: t('content.main'),
                btnCreate: t('content.btnCreate'),
                haveAcount: t('content.haveAcount'),
                login: t('content.login')
            }
        }
    }
    function getLiteralsUserPage(t: any) {
        return {
            title: t("loginPage.title"),
            desc: t("loginPage.desc"),
            message: { maintext: t("loginPage.message.maintext") },
            inputmail: { maintext: t("loginPage.inputmail.maintext") },
            inputpass: { maintext: { maintext: t("loginPage.inputpass.maintext.maintext") } },
            button1: t("loginPage.button1"),
            button2: t("loginPage.button2")
        };
    }


    const [tHome] = useTranslation("home");
    const literalsHome = getLiteralsHome(tHome);

    const [tLogin] = useTranslation("login");
    const literalsLogin = getLiteralsUserPage(tLogin);

    return (
        <>
            <div>
                {
                    props?.view === 'home' ? (
                        <>
                            <PWelcomeNew
                                literals={literalsHome}
                                onLoginSocialClicked={handleLoginSocial}
                            />
                        </>
                    )
                        :
                        (
                            <>
                                <UserLogin
                                    literals={literalsLogin}
                                // onLoginSocialClicked={handleLoginSocial}
                                />
                            </>
                        )
                }

            </div>
        </>
    )
}
